import script from "./FutureTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./FutureTasks.vue?vue&type=script&setup=true&lang=js"

import "./FutureTasks.vue?vue&type=style&index=0&id=371070e4&lang=scss"

const __exports__ = script;

export default __exports__